import PageSeo from "@/components/PageSeo";
import ContactFormSection from "@/components/sections/ContactFormSection";
import CtaBannerSection from "@/components/sections/CtaBannerSection";
import HeroSection from "@/components/sections/HeroSection";
import ResourcesGridSection from "@/components/sections/ResourcesGridSection";
import { contactPageContent } from "@/content/pages/contactPage";

const ContactPage = () => {
  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={contactPageContent.seo} />
      <HeroSection content={contactPageContent.hero} dataTestId="contact-hero" />
      <ResourcesGridSection content={contactPageContent.contactChannels} dataTestId="contact-options" className="bg-muted/50" />
      <ContactFormSection content={contactPageContent.formSection} dataTestId="contact-form" />
      <CtaBannerSection content={contactPageContent.finalCta} dataTestId="contact-cta" />
    </div>
  );
};

export default ContactPage;
